import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SHOP_LOCATOR } from '../../../routes/externalLinks';
import { close } from '../../../modules/modal/actions';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { plusCardSmall } = contentStackImageUrls;

export const AnonSaveSlip = ({ closeModal }) => (
  <div className="modal anon-save-slip">
    <div className="anon-save-slip__close-button" onClick={closeModal}>
      <i className="icon icon--close" />
    </div>
    <img
      src={plusCardSmall}
      onError={(e) => { e.target.src = '../../../../assets/images/plus-card-small.png'; }}
      className="anon-save-slip__image"
    />
    <h1 className="anon-save-slip__header">
      Not yet a PLUS customer?
    </h1>
    <p className="anon-save-slip__text">
      Visit a William Hill shop and sign up for a PLUS card to
      make the most of BettingBuddy and other great PLUS features.
    </p>
    <a
      className="anon-save-slip__action-text"
      target="_blank"
      href={SHOP_LOCATOR}
      rel="noopener noreferrer"
    >
      Find your nearest shop
    </a>
  </div>
);

AnonSaveSlip.propTypes = {
  closeModal: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  closeModal: close
};

export default connect(null, mapDispatchToProps)(AnonSaveSlip);
